import GnlKullaniciAyarDTO from "../Base/Auth/GnlKullaniciAyarDTO";

class ReportMailRequest {
    reportEntry?: string = "";
    to?: Array<GnlKullaniciAyarDTO> = [];
    cc?: Array<GnlKullaniciAyarDTO> = [];
    subject?: string = "";
    isAttachment?: boolean = true;
}

export default ReportMailRequest;